import moment from 'moment';
import { retainHistoryColumns } from '../../../constants/tableColumns';
import { useRetainHistoryContext } from '../../../contexts/RetainHistoryProvider';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../../CommonComps/Tables/AcademiaTable';
import PageHeader from '../../CommonComps/Titles/PageHeader';

const ShowAllRetainHistory = () => {
  // integration of context hooks here
  const { retainHistoryList, isError, isLoading, isSuccess } =
    useRetainHistoryContext();

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions(
    'retainerAgreement',
    true
  );

  // rendering show all retain history section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader headerText='Retain History' />

            <AcademiaTable
              data={retainHistoryList.map((retain) => ({
                ...retain,
                start_date: moment(retain.start_date).format('DD-MM-YYYY'),
                end_date: moment(retain.end_date).format('DD-MM-YYYY'),
              }))}
              columns={retainHistoryColumns}
              notFoundMessage='No Retain history found!'
            />
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load retain history data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllRetainHistory;
